// extracted by mini-css-extract-plugin
export default {"wrapper":"loader_wrapper__eH2iR","open":"loader_open__AicJt","content":"loader_content__pKFSY","close":"loader_close__suoRH"};